import * as React from 'react'
import { Box, styled, Typography } from '@mui/material'
import RimonimLogo from '@assets/AppLogo.png'
import { getAccountLogoUrl } from '@/services/dashboardService'
import { useAppTheme } from '@/theme/ThemeContext'

const TitleStyledTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isDarkMode',
})<{ isDarkMode?: boolean }>(({ isDarkMode }) => ({
  color: isDarkMode ? '#BBD7FF' : '#000',
  textAlign: 'right',
  fontFamily: 'Rubik',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 300,
  lineHeight: '100%',
}))

const CaptionStyledTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isDarkMode',
})<{ isDarkMode?: boolean }>(({ isDarkMode }) => ({
  color: isDarkMode ? '#94A3B8' : '#8F98A5',
  textAlign: 'right',
  fontFamily: 'Rubik',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 300,
  lineHeight: '140%',
}))

type SiteLogoProps = {
  accountId?: string | number | null
}

/**
 * Shows the site logo the header shows. There is no logo upload: no Gateway
 * route and no storage exist for one, so the only honest controls are none.
 */
const SiteLogo = ({ accountId }: SiteLogoProps) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const siteLogoUrl =
    accountId === null || accountId === undefined || accountId === ''
      ? null
      : getAccountLogoUrl(accountId)

  const [logoMissing, setLogoMissing] = React.useState(false)
  React.useEffect(() => setLogoMissing(false), [siteLogoUrl])

  const showFallback = !siteLogoUrl || logoMissing

  return (
    <Box sx={{ marginTop: '20px' }}>
      <TitleStyledTypography isDarkMode={isDarkMode}>
        תמונת אתר
      </TitleStyledTypography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: '20px' }}>
        <img
          width="100px"
          height="100px"
          src={showFallback ? RimonimLogo : siteLogoUrl}
          alt={showFallback ? 'לוגו רימונים' : 'לוגו האתר'}
          onError={() => setLogoMissing(true)}
          style={{ objectFit: 'contain' }}
        />
        {showFallback && (
          <CaptionStyledTypography isDarkMode={isDarkMode}>
            לא הוגדרה תמונה לאתר. מוצג הלוגו של רימונים.
          </CaptionStyledTypography>
        )}
      </Box>
    </Box>
  )
}

export default SiteLogo
